import * as React from 'react'
import MUIListItem from '@mui/material/ListItem'

const ListItem = (props) => <MUIListItem {...props} />

export default ListItem
